import { IconColorType } from '@frontend/icons';
import { ButtonProps, ButtonVariants } from '../button.type';
import { primaryClassName } from './primary.styles';
import { secondaryClassName } from './secondary.styles';
import { tertiaryClassName } from './tertiary.styles';

export const getIconColor: (variant: ButtonVariants, disabled?: boolean, destructive?: boolean) => IconColorType = (
  variant,
  disabled,
  destructive
) => {
  if (disabled) {
    switch (variant) {
      case 'primary':
        return 'white';
      case 'secondary':
        return 'disabled';
      case 'tertiary':
        return 'disabled';
    }
  } else if (destructive) {
    switch (variant) {
      case 'primary':
        return 'white';
      case 'secondary':
        return 'error';
      case 'tertiary':
        return 'error';
    }
  } else {
    switch (variant) {
      case 'primary':
        return 'white';
      case 'secondary':
        return 'default';
      case 'tertiary':
        return 'primary';
      default:
        return 'primary';
    }
  }
};

export const getLoaderColor = (variant: ButtonVariants, destructive: boolean) => {
  if (destructive) {
    switch (variant) {
      case 'primary':
        return 'error';
      case 'secondary':
        return 'error';
      case 'tertiary':
        return 'error';
    }
  } else {
    switch (variant) {
      case 'primary':
        return 'primary';
      case 'secondary':
        return 'subdued';
      case 'tertiary':
        return 'primary';
    }
  }
};

export const getVariantClassName = ({
  variant,
  size,
  loading = false,
  iconOnly,
  destructive,
  showFocusOutline,
}: Pick<ButtonProps, 'destructive' | 'loading' | 'size' | 'variant' | 'showFocusOutline'> & {
  iconOnly: boolean;
}) => {
  switch (variant) {
    case 'primary':
      return primaryClassName({
        size,
        isLoading: loading,
        iconOnly,
        destructive,
        showFocusOutline,
      });

    case 'secondary':
      return secondaryClassName({
        size,
        isLoading: loading,
        iconOnly,
        destructive,
        showFocusOutline,
      });

    case 'tertiary':
      return tertiaryClassName({
        size,
        isLoading: loading,
        iconOnly,
        destructive,
        showFocusOutline,
      });

    default:
      return primaryClassName({
        size,
        isLoading: loading,
        iconOnly,
        destructive,
        showFocusOutline,
      });
  }
};
